import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const GalleryById = async (id) => {
  try {
    return await getData(`/website/galleryshow/galleryphoto/${id}`);
  } catch (error) {
    console.log(error);
  }
};


export const getAllGallerys = async (id, pageNo) => {
  try {
    return await getData(`/website/galleryshow/galleryphoto`);
  } catch (error) {
    console.log(error);
  }
};

export const GalleryCategorys = async () => {
  try {
    return await getData(`/website/galleryshow/gallerycategory`);
  } catch (error) {
    console.log(error);
  }
};

